module.exports = __webpack_public_path__ + "5f89b7abd0b95df1619c092ccbabee12.svg";